import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import AvatarLink from '../avatarLink/avatarLink'
import Button from '../../ui/button'
import UsersTable from '../../ui/table'
import Title from '../../ui/title/title'

import { ColumnDescription } from 'react-bootstrap-table-next'

import { RootState } from '../../../store/rootReducer'
import { FolloweeItem } from '../../../store/member/memberTypings'

import { deleteFavoriteContributor, fetchFavoriteContributors } from '../../../store/member/memberSlice'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { genders } from '../../../constants/index'

interface Props {
    favorites?: FolloweeItem[]
    nickDirection: boolean
    setNickDirection: React.Dispatch<boolean>
    ageDirection: boolean
    setAgeDirection: React.Dispatch<boolean>
    order: string
    setActivePage: React.Dispatch<number>
}

const FavoriteList: React.FunctionComponent<Props> = ({
    favorites,
    nickDirection,
    setNickDirection,
    ageDirection,
    setAgeDirection,
    order,
    setActivePage
}: Props) => {
    const [t] = useTranslation()
    const dispatch = useDispatch()

    const { followeesTotal } = useSelector((state: RootState) => state.member)

    const changeDirection = (param: string) => {
        if (param === `${keyField}.nick`) {
            setNickDirection(!nickDirection)
            setAgeDirection(null)
        }
        if (param === `${keyField}.age`) {
            setAgeDirection(!ageDirection)
            setNickDirection(null)
        }
    }

    const sortCaret = (order: string, column: ColumnDescription & { label: string }) => (
        <div className={`sort ${order}`} onClick={() => changeDirection(column.dataField)}>
            <div className="text">{column.label}</div>
            <div className="arrow" />
        </div>
    )

    const deleteFavorite = (cell: string, row: FolloweeItem) => {
        return (
            <Button
                small
                label={t('Delete')}
                // @ts-ignore
                onClick={(e) => {
                    e.stopPropagation()
                    setActivePage(1)
                    dispatch(fetchFavoriteContributors({ p: 1, order: order }))
                    dispatch(deleteFavoriteContributor({ id: row.followee.id }))
                }}
            />
        )
    }

    const avatar = (cell: string) => <AvatarLink img={cell} nick={cell.split('/')[2]} />

    const gender = (cell: string) => {
        return t(genders.find((x) => x.value === cell).label)
    }

    const keyField = 'followee'

    const location = (cell: string, row: FolloweeItem) => {
        return `${cell}${
            get(row, `${keyField}.country`) && get(row, `${keyField}.region`)
                ? `, ${get(row, `${keyField}.region`)}`
                : ''
        }`
    }

    const columns = [
        {
            dataField: `${keyField}.avatar_url`,
            text: '',
            formatter: avatar
        },
        {
            sort: true,
            //@ts-ignore
            sortFunc: () => null,
            dataField: `${keyField}.nick`,
            label: t('Nick'),
            sortCaret,
            text: ''
        },
        {
            text: t('Sex'),
            dataField: `${keyField}.gender`,
            formatter: gender
        },
        {
            text: '',
            sortCaret,
            sort: true,
            //@ts-ignore
            sortFunc: () => null,
            label: t('Age'),
            dataField: `${keyField}.age`
        },
        {
            text: t('Location'),
            formatter: location,
            dataField: `${keyField}.country`
        },
        ...(!isEmpty(favorites)
            ? [
                  {
                      text: '',
                      dataField: '',
                      formatter: deleteFavorite
                  }
              ]
            : [])
    ]

    const renderTable = () => (
        <UsersTable title={t('')} columns={columns} followees={favorites} listLength={followeesTotal} favorite />
    )

    const renderEmpty = () => {
        return <Title text={'You have no favorite contributors'} secondary />
    }

    return <>{!isEmpty(favorites) ? renderTable() : renderEmpty()}</>
}

export default FavoriteList
